import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp } from '@fortawesome/pro-regular-svg-icons';

export default class SlideDown extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    defaultActive: PropTypes.bool,
    hoverable: PropTypes.bool,
    icon: PropTypes.object,
    minHeight: PropTypes.number,
    color: PropTypes.oneOf(['dark', 'light']),
  }

  static defaultProps = {
    icon: faAngleUp,
    defaultActive: false,
    minHeight: 100,
    hoverable: false,
    color: 'light'
  }

  constructor(props) {
    super(props);
    this.content = React.createRef();
    this.state = {
      active: props.defaultActive,
      isSmall: false,
    };
  }

  componentDidMount() {
    this.setStyles();
    window.addEventListener('resize', this.setStyles);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setStyles);
  }

  setStyles = () => {
    this.content.current.style.height = 'auto';
    this.height = this.content.current.getBoundingClientRect().height;
    this.content.current.style.height = `${this.content.current.getBoundingClientRect().height}px`;

    if (!this.state.active && this.height >= this.props.minHeight) {
      this.content.current.style.height = `${this.props.minHeight}px`;
    }

    if (this.height < this.props.minHeight) {
      this.setState({ isSmall: true });
    } else {
      // Add a bit of height so the icon doesn't overlap when full size
      this.height = this.height + 10;
      this.setState({ isSmall: false });
    }
  }

  get classNames() {
    const { className, hoverable, color } = this.props;
    return classNames('slide-down-container relative', {
      [className]: className,
      'is-active': this.state.active,
      'is-hoverable': hoverable,
      'is-dark': color === 'dark'
    });
  }

  toggle = (e) => {
    e && e.preventDefault();
    this.setState({ active: !this.state.active });
  };

  render() {
    const { children, icon, minHeight } = this.props;
    const { active, isSmall } = this.state;

    const renderProps = (typeof children === 'function');

    return(
      <div className={this.classNames}>
        <div
          className='slide-down-content'
          style={{overflow: 'hidden', height: (active ? this.height : minHeight)}}
          ref={this.content}
        >
          {renderProps ? children({ onTextChange: () => this.setStyles() }) : children}
        </div>
        {
          !isSmall &&
          <button className='slide-down-button' onClick={this.toggle}>
            <FontAwesomeIcon icon={icon} />
          </button>
        }
      </div>
    );
  }
}
